export default "__VITE_ASSET__bGQwZKcq__ 778w";